import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addArticle, getAllArticles } from "../../REDUX/actions/articles";
import CustomButton from "../Common/CustomButton";
import EmptyList from "../Common/EmptyList";
import Loading from "../Common/Loading";
import InputText from "../sectioninput/formelement/InputText";
import ArticleCard from "./ArticleCard";

const ArticlesList = ({
  title = "Liste des articles",
  articlesLoading,
  articles,
  buttonText = "Ajouter un article",
  type = 0,
}) => {
  const dispatch = useDispatch();
  const [filter, setfilter] = useState("");

  const createArticle = () => dispatch(addArticle(type));
  const filterArticles = () => {
    dispatch(getAllArticles(filter, type));
  };
  return (
    <div className="bg-white rounded-10 container-fluid p-5 shadowed">
      <div className="row f24 align-items-center">{title}</div>
      <div className="row align-items-center mt-2">
        <div className="col-9 d-flex align-items-center">
          <InputText
            flag={false}
            placeholder="rechercher un article"
            handleChange={setfilter}
          />
          <div className="ms-3 col-1">
            <CustomButton
              iconStart={"search"}
              callBack={() => filterArticles(filter)}
            />
          </div>
        </div>
        <div className="col-3">
          <CustomButton
            buttonText={buttonText}
            iconStart={"plus-lg"}
            callBack={createArticle}
          />
        </div>
      </div>
      <div className="row mb-4 w-98 m-auto mt-5">
        <div className="col-4 f16 bolder text-start">Titre</div>
        <div className="col-2 f16 bolder text-start">Publié</div>
        <div className="col-4 f16 bolder text-start">Actions</div>
        <div className="col-2 f16 bolder text-start">Type</div>
      </div>
      {articlesLoading ? (
        <Loading />
      ) : (
        <div className="mt-5">
          {articles.length ? (
            articles.map((article, index) => (
              <ArticleCard key={index} article={article} index={index} />
            ))
          ) : (
            <EmptyList text="Pas d'articles" />
          )}
        </div>
      )}{" "}
    </div>
  );
};

export default ArticlesList;
